/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto,
  WebApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDto,
  WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDto,
  WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto,
} from '../models';
import {
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoToJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDtoToJSON,
    WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDtoFromJSON,
    WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDtoToJSON,
    WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoFromJSON,
    WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoToJSON,
} from '../models';

export interface ApiSubscriptionCreatePostRequest {
    webApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDto?: WebApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDto;
}

export interface ApiSubscriptionInvoicesInvoiceIdPdfGetRequest {
    invoiceId: number;
}

/**
 * 
 */
export class SubscriptionApi extends runtime.BaseAPI {

    /**
     * Creates new subscription
     */
    async apiSubscriptionCreatePostRaw(requestParameters: ApiSubscriptionCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Subscription/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDtoToJSON(requestParameters.webApiServicesDataTransferObjectsReplyServiceCreateSubscriptionDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDtoFromJSON(jsonValue));
    }

    /**
     * Creates new subscription
     */
    async apiSubscriptionCreatePost(requestParameters: ApiSubscriptionCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsReplyServiceCreateReplyResultDto> {
        const response = await this.apiSubscriptionCreatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets invites by eventId
     */
    async apiSubscriptionGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Subscription`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDtoFromJSON(jsonValue));
    }

    /**
     * Gets invites by eventId
     */
    async apiSubscriptionGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsSubscriptionServiceAccountInformationResultDto> {
        const response = await this.apiSubscriptionGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Lists the invoices OneFront has sent to the caller\'s company.
     */
    async apiSubscriptionInvoicesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Subscription/invoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDtoFromJSON));
    }

    /**
     * Lists the invoices OneFront has sent to the caller\'s company.
     */
    async apiSubscriptionInvoicesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiServicesDataTransferObjectsSubscriptionServiceCompanyInvoiceListItemDto>> {
        const response = await this.apiSubscriptionInvoicesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Streams one of the caller\'s company\'s invoice PDFs. The blob container is private, so the  PDF goes through the API. An invoice belonging to another company returns 404.
     */
    async apiSubscriptionInvoicesInvoiceIdPdfGetRaw(requestParameters: ApiSubscriptionInvoicesInvoiceIdPdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.invoiceId === null || requestParameters.invoiceId === undefined) {
            throw new runtime.RequiredError('invoiceId','Required parameter requestParameters.invoiceId was null or undefined when calling apiSubscriptionInvoicesInvoiceIdPdfGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Subscription/invoices/{invoiceId}/pdf`.replace(`{${"invoiceId"}}`, encodeURIComponent(String(requestParameters.invoiceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Streams one of the caller\'s company\'s invoice PDFs. The blob container is private, so the  PDF goes through the API. An invoice belonging to another company returns 404.
     */
    async apiSubscriptionInvoicesInvoiceIdPdfGet(requestParameters: ApiSubscriptionInvoicesInvoiceIdPdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiSubscriptionInvoicesInvoiceIdPdfGetRaw(requestParameters, initOverrides);
    }

}
